import { z } from "zod";
import { locales } from "../models.js";

export default {
  params: z.object({
    accountName: z.string(),
    operatorLanguage: z.enum(locales),
    siren: z
      .string()
      .regex(/^\d{9}$/)
      .optional(),
    creatorPersonKey: z.string().min(1).optional(),
  }),
  response: z.string(),
};
